import { render } from "./HasilUji.vue?vue&type=template&id=b2b67bd2"
import script from "./HasilUji.vue?vue&type=script&lang=js"
export * from "./HasilUji.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__